import { BiSolidBarChartAlt2 } from 'react-icons/bi';
import ListDashboard from './ListDashboard';

export default {
  name: 'dashboard',
  list: ListDashboard,
  icon: BiSolidBarChartAlt2,
  options: {label: 'Dashboard'}
};